import { render, staticRenderFns } from "./VideoManage.vue?vue&type=template&id=1d0a25cc&scoped=true"
import script from "./VideoManage.vue?vue&type=script&lang=js"
export * from "./VideoManage.vue?vue&type=script&lang=js"
import style0 from "./VideoManage.vue?vue&type=style&index=0&id=1d0a25cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0a25cc",
  null
  
)

export default component.exports